import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateHealthCheckStatus } from '@/modules/estatehealthcheck/constants/EstateHealthCheckStatus';
import { EstateHealthCheckAnswer } from '@/modules/estatehealthcheck/models/EstateHealthCheckAnswer';
import { Estate } from '@/modules/estate/models/Estate';
import { User } from '@/modules/user/models/User';

export class EstateHealthCheck extends BaseEntityModel {
  id?: number;
  estateId?: number;
  status?: string;
  year?: number;
  additionalNotes?: string;
  createdByUserId?: number;
  updatedByUserId?: number;
  submittedByUserId?: number;
  submittedAt?: string;
  createdAt?: string;
  updatedAt?: string;

  estateHealthCheckAnswers?: Relationship<EstateHealthCheckAnswer[]>;
  estate?: Relationship<Estate>;
  createdByUser?: Relationship<User>;
  updatedByUser?: Relationship<User>;
  submittedByUser?: Relationship<User>;

  constructor(model: Partial<EstateHealthCheck> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.status = model.status;
    this.year = model.year;
    this.additionalNotes = model.additionalNotes;
    this.createdByUserId = model.createdByUserId;
    this.updatedByUserId = model.updatedByUserId;
    this.submittedByUserId = model.submittedByUserId;
    this.submittedAt = model.submittedAt;
    this.createdAt = model.createdAt;
    this.updatedAt = model.updatedAt;

    this.estateHealthCheckAnswers = EstateHealthCheckAnswer.mapModelsOrNull(model.estateHealthCheckAnswers);
    this.estate = Estate.mapModel(model.estate);
    this.createdByUser = User.mapModelOrNull(model.createdByUser);
    this.updatedByUser = User.mapModelOrNull(model.updatedByUser);
    this.submittedByUser = User.mapModelOrNull(model.submittedByUser);
  }

  get isCouplesPlan(): boolean {
    return !!this.estate?.isCouplesPlan;
  }

  get isNotStarted(): boolean {
    return this.status === EstateHealthCheckStatus.NOT_STARTED;
  }

  get isInProgress(): boolean {
    return this.status === EstateHealthCheckStatus.IN_PROGRESS;
  }

  get isCompletedStatus(): boolean {
    return this.status === EstateHealthCheckStatus.COMPLETED;
  }

  get isWaitingForPartnerReview(): boolean {
    return this.status === EstateHealthCheckStatus.WAITING_FOR_PARTNER_REVIEW;
  }

  get answers(): EstateHealthCheckAnswer[] {
    return this.estateHealthCheckAnswers || [];
  }

  get familyEventAnswers(): EstateHealthCheckAnswer[] {
    return this.answers.filter((answer: EstateHealthCheckAnswer) => answer.isFamilyEvent);
  }

  get peopleInPlanAnswers(): EstateHealthCheckAnswer[] {
    return this.answers.filter((answer: EstateHealthCheckAnswer) => answer.isPeopleInPlan);
  }

  get moneyAndPropertyAnswers(): EstateHealthCheckAnswer[] {
    return this.answers.filter((answer: EstateHealthCheckAnswer) => answer.isMoneyAndProperty);
  }

  get businessAnswers(): EstateHealthCheckAnswer[] {
    return this.answers.filter((answer: EstateHealthCheckAnswer) => answer.isBusiness);
  }

  get locationAnswers(): EstateHealthCheckAnswer[] {
    return this.answers.filter((answer: EstateHealthCheckAnswer) => answer.isLocation);
  }
}
